"use client";

import React, { useState } from "react";
import RestaurantTopBar from "@/components/demos/restaurant/RestaurantTopBar";

export default function RestaurantDemoClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");
  const [resetKey, setResetKey] = useState(0);

  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 flex flex-col font-sans selection:bg-amber-600 selection:text-white">
      <RestaurantTopBar
        currency={currency}
        onCurrencyChange={(c) => setCurrency(c)}
        onResetComplete={() => setResetKey((prev) => prev + 1)}
      />
      <main className="flex-grow" key={resetKey}>
        {React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement<any>, { currency })
          : children}
      </main>
    </div>
  );
}
